// CompletionStep Component
// Step 5: Success screen after club creation

import React from 'react';
import { 
  FaCheck, 
  FaEye, 
  FaPlus, 
  FaTimes,
  FaBuilding,
  FaTags,
  FaBell,
  FaUserShield
} from 'react-icons/fa';
import styles from './CompletionStep.module.css';

const CompletionStep = ({ club, categoriesCount, onViewClub, onCreateAnother, onClose }) => {
  const completedItems = [
    { icon: FaBuilding, text: 'Club details saved' },
    { icon: FaTags, text: `${categoriesCount} categories created` },
    { icon: FaBell, text: 'Notification settings configured' },
    { icon: FaUserShield, text: "You're now the Creator & Admin" }
  ];

  // Get club logo display URL
  const getLogoUrl = () => {
    if (!club?.clubLogo) return null;
    if (typeof club.clubLogo === 'string') return club.clubLogo;
    return club.clubLogo?.transformedUrls?.medium || club.clubLogo?.url || null;
  };

  const logoUrl = getLogoUrl();

  return (
    <div className={styles.container}>
      {/* Close Button */}
      <button className={styles.closeButton} onClick={onClose} aria-label="Close">
        <FaTimes />
      </button>

      {/* Content */}
      <div className={styles.content}>
        {/* Success Animation */}
        <div className={styles.successIcon}>
          <div className={styles.successCircle}>
            <FaCheck className={styles.checkIcon} />
          </div>
          <div className={styles.confetti}>
            {[...Array(12)].map((_, i) => (
              <div key={i} className={styles.confettiPiece} style={{ '--i': i }} />
            ))}
          </div>
        </div>

        <h1 className={styles.title}>Club Created Successfully!</h1>

        {/* Club Preview */}
        <div className={styles.clubPreview}>
          {logoUrl ? (
            <img src={logoUrl} alt={club?.name} className={styles.clubLogo} />
          ) : (
            <div className={styles.clubLogoPlaceholder}>
              <FaBuilding />
            </div>
          )}
          <div className={styles.clubInfo}>
            <h2 className={styles.clubName}>{club?.name || 'Your Club'}</h2>
            <span className={styles.clubSport}>{club?.sport} Club</span>
          </div>
        </div>

        {/* Completion Checklist */}
        <div className={styles.checklist}>
          {completedItems.map((item, index) => (
            <div key={index} className={styles.checklistItem}>
              <div className={styles.checklistIcon}>
                <FaCheck />
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          <button className={styles.primaryButton} onClick={onViewClub}>
            <FaEye />
            View Club
          </button>
          <button className={styles.secondaryButton} onClick={onCreateAnother}>
            <FaPlus />
            Create Another Club
          </button>
        </div>

        <button className={styles.textButton} onClick={onClose}>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default CompletionStep;

